"use client";

import React from 'react';

const NexHealthBookingButton: React.FC = () => {
  const handleClick = () => {
    window.open('https://app.nexhealth.com/appt/smile4me_dental_care?lid=77847&tracking_key=b2d71902-5ce0-43c1-bc95-24cdee27de9a', '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      className="fixed bottom-6 right-6 z-50 group bg-black hover:bg-[#1a1a1a] font-bold w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-105 transition-all duration-300 ease-in-out flex items-center justify-center cursor-pointer border-2 border-transparent bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] p-[2px]"
      onClick={handleClick}
      aria-label="Book an appointment online with Smile4Me Dental Care"
      type="button"
    >
      <div className="bg-black hover:bg-[#1a1a1a] w-full h-full rounded-full flex items-center justify-center transition-colors duration-300">
        <span className="text-[10px] sm:text-xs md:text-sm font-extrabold text-center leading-[1.1] tracking-tight uppercase bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent">
          Book<br />Online<br />
          <span className="text-[8px] sm:text-[9px] md:text-[10px] font-normal normal-case">by NexHealth</span>
        </span>
      </div>
    </button>
  );
};

export default NexHealthBookingButton;